import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { Observable, Subject } from 'rxjs';
import { HelpersService } from '../helpers/helpers.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrendsService {
  private update = new Subject<{ startDate: string, endDate: string }>();
  startDateForApi: string = ''
  endDateForApi: string = ''
  
  constructor(public _utilsService: UtilsService, private http: HttpClient,private _helpersService: HelpersService) { }
  url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.EngagementSummaryByAccount);
  updateTrends(dates: { startDate: string, endDate: string }) {
    this.update.next(dates)
  }

  getDates(): Observable<{ startDate: string, endDate: string }> {
    return this.update.asObservable();
  }

  getTrends(payload: any) {
    return this._utilsService.postAPICall(this.url, payload, this._utilsService.setHeaders())
  }

  /**
     * this function is used to get api payload
     * @param view_type string
     * @param query_type number
     * @param field_id string
     * @returns 
     */
  getApiParameter(view_type, query_type, dates, field_id?) {
    let isAccount = true;// localStorage.getItem('isAccount');
    isAccount = (isAccount == true || isAccount == 'true');
    // let parameter = JSON.parse(localStorage.getItem('QUERY_PARAM_OBJ'));
    let params: any = {
      "from": dates.startDate ? dates.startDate : this._helpersService.helpers['datePicker'].startDate,
      "to": dates.endDate ? dates.endDate : this._helpersService.helpers['datePicker'].endDate,
      "is_trend_data": false,
      "is_custom_date_range_selected": false,
      "rater_type": -1,
      "view_type": "summary",
      "query_type": (query_type) ? query_type : 1
    }
    // let account_id = localStorage.getItem('LtMsAcTiDfR')
    // if (account_id) {
    // }
    if (!isAccount) {
      /* params.hierarchy_stack = Helpers.getHierarchyStack();
      params.shop_id = (Helpers.touchpointId) ? Helpers.touchpointId : null;
      params.rater_type = (Helpers.brandDetail && Helpers.brandDetail.main_rater_type) ? Helpers.brandDetail.main_rater_type : null;
      params.timezone_offset = this.hasProperty(Helpers.brandDetail, 'default_time_zone.offset') ? Helpers.brandDetail.default_time_zone.offset : 0
      params.brand_id = (parameter && parameter.brand_id) ? parameter.brand_id : Helpers.brandDetail._id;
      if (parameter.manager_type == 2) {
          params.brand_id = parameter.brand_id;
      } else if (parameter.manager_type == 7) {
          params.group_id = parameter.group_id;
      } else if (parameter.manager_type == 1) {
          params.shop_id = parameter.shop_id;
      }
      // params.group_id = Helpers.groupId || parameter.group_id;
      params.shop_id = Helpers.touchpointId || parameter.shop_id;
      if(!Helpers.touchpointId && Helpers.shopIdList && Helpers.shopIdList.length){
          params.shop_id_list = Helpers.shopIdList;
          delete params.shop_id;
      } */
    } else {
      params.timezone_offset = -330;
      // this.hasProperty(Helpers.accountDetails[account_id], 'default_time_zone.offset') ? Helpers.accountDetails[account_id].default_time_zone.offset : 0
    }
    params.view_type = view_type
    if (view_type == "trials") {
      params.query_type = 5
    }
    if (view_type == "hierarchy") {
      params.field_id = field_id
    }
    return params;
  }

  /*
    @Author - Bhunesh
    @Created on  - 30th Jan 2017
    @Description - 
        - Calculates responded percentage
    Changes - 
        - Checking for NAN e.g. 0/0
        - Formula changes for Response%
        - Formula added is #Responses/(#Delivered or #Sent)
        - Removed Unique Invitaion and Reminder fields
 */
  getResponsePercentage(data) {
    data = JSON.parse(JSON.stringify(data));
    data.number_of_unique_delivered = data.number_of_unique_delivered || data.number_of_unique_sent || 0;
    data.responded_percentage = 0;
    // let totalRatings = (data.number_of_request_generated_rated)?data.number_of_request_generated_rated:
    let totalResponded = 0;

    if (data.number_of_request_generated_rated) {
      totalResponded = data.number_of_request_generated_rated;
    } else if (data.number_of_users_rated) {
      totalResponded = data.number_of_users_rated;
    }

    // Added by Hitesh on 15th jun 2018 - if "number_of_unique_delivered == NA" then set the value as 0
    let delivered = (data.number_of_unique_delivered == 'NA' || !data.number_of_unique_delivered) ? 0 : data.number_of_unique_delivered;
    if (data.utm_medium_link) {
      delivered = delivered + data.utm_medium_link;
    }
    if (data.utm_medium_kiosk) {
      delivered = delivered + data.utm_medium_kiosk;
    }
    if (data.utm_medium_qrcode) {
      delivered = delivered + data.utm_medium_qrcode;
    }

    if (delivered >= totalResponded) {
      data.responded_percentage = (totalResponded / delivered) * 100;
    }
    // Added by Bhunesh on 6th Feb 2017 - To support old response% formula if data is not available
    // Code commented by Bhunesh - 21st March 2017 - As all data are migrated for new calculations
    // if ((data.number_of_unique_delivered == 0 || data.number_of_unique_delivered == "NA") && totalResponded > 0) {
    //     data.responded_percentage = (data.number_of_request_generated_rated / ((data.number_of_request_generated + data.number_of_request_generated_rated) - (data.number_of_duplicate_requests + (data.number_of_invalid_sms_trial_1 + data.number_of_invalid_email_trial_1))) * 100) || 0;
    //     if (!isFinite(data.responded_percentage)) {
    //         data.responded_percentage = 0;
    //     }
    // }

    // Added by Raj for LI/WEB response rate calculation
    /* if (Helpers.brandDetail && Helpers.brandDetail.project_info && Helpers.brandDetail.project_info.response_medium && Helpers.brandDetail.project_info.response_medium.toString() == "4") {
        let totalRequests = totalResponded
        if (!isNaN(data.number_of_request_generated)) {
            totalRequests += parseInt(data.number_of_request_generated);
        }
        if (totalResponded != 0 && totalRequests != 0) {
            data.responded_percentage = (totalResponded / totalRequests) * 100;
        }
    } */
    let responded_percentage = isNaN(data.responded_percentage) ? 0 : data.responded_percentage;
    return responded_percentage;
  };

  /**
 * this function used to get response rate percentage
 * @param summary summary object
 * @param is_icon_enabled boolean
 * @returns percetage
 */
  getResponeRate(summary, is_icon_enabled = false) {
    let response_rate = 0
    if (!_.isEmpty(summary)) {
      summary.number_of_unique_delivered = summary.number_of_unique_requests_delivered;
      if (summary.number_of_requests_received == 0 && summary.number_of_unique_requests_delivered == 0 && summary.number_of_request_generated_rated == 0) {
        response_rate = 0;
      } else if ((summary.number_of_requests_received == summary.number_of_request_generated_rated) && summary.number_of_request_generated_rated >= 0) {
        response_rate = 100;
      } else {
        response_rate = (this.getResponsePercentage(summary)).toFixed(1);
      }
    }
    return (response_rate && is_icon_enabled) ? response_rate + "%" : response_rate;
  }

  /**
 * this function used to get response score 
 * @param data 
 * @param rater_type 
 * @returns 
 */
  getResponseScore(data, rater_type) {
    let score = 0;
    if (data && data.number_of_request_generated_rated) {

      if (rater_type == 3 || rater_type == 10) {
        let sum = (data.promoters || 0) + (data.passives || 0) + (data.detractors || 0);
        score = (sum > 0) ? parseFloat(((((data.promoters || 0) / sum) * 100) - (((data.detractors || 0) / sum) * 100)).toFixed(1)) : 0;
        score = parseFloat(score.toString());
      } else {
        score = parseFloat(this.getAverageRating(data).toFixed(1));
      }
    }
    return score;
  }

  /**
 * this fuction adds the number of requests generated and rated, defaulting to 0 if they don't exist.
 * @param data 
 * @returns 
 */
  getRequestRecieved(data) {
    return (data.number_of_request_generated || 0) + (data.number_of_request_generated_rated || 0)
  }

  /**
 * this function will Calculates average rating from data, returning 0 if an error occurs.
 * @param data 
 * @returns 
 */
  getAverageRating(data) {
    let averageRating = 0;
    try {
      if (data) {
        if (data.sum_primary_rating && data.number_of_users_rated_primary_rating) {
          averageRating = (data.sum_primary_rating) / (data.number_of_users_rated_primary_rating);
        } else {
          averageRating = 0;
        }
      }
    } catch (e) {
      averageRating = 0;
    }
    return averageRating;
  }

  // Returns the value of a nested property in an object.
  getProp(obj: any, str: string): any {
    str = str.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    str = str.replace(/^\./, ''); // strip a leading dot
    const a = str.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (obj && typeof obj === 'object') {
        if (k in obj) {
          obj = obj[k];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
    return obj;
  }


}
